import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import store from '@/assets/common/store/store';
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import * as XLSX from "xlsx";
import ChemicalCropLinkRegisterModal from '@/assets/common/Modal/ChemicalCropLinkRegisterModal/ChemicalCropLinkRegisterModal.vue';

type Hiragana = {
    id: string;
    name: string;
    hiragana : string;
    parentCropName?: string;
    parentCropId?: string | null;
    aliasNames?: string;
    cropType : number|null;
    largeCropG : string|null;
    mediumCropG : string|null;
    smallCropG : string|null;
    isDisabled : boolean;
    searchQueryParentCropName: string;
    isParentCropNameDropdownVisible: boolean;
    processType: 'new' | 'update' | 'nochange';
    hasError: boolean;
    isConfirm: boolean;
    mediumCrops:any[],
    smallCrops:any[],
    parentCropNameList: any[]
    changedFields?: string[];
    deletedCropFamic: { cropId: string, name: string }[],
    selectedImportType : number
}

@Component({
    components: {
        EmptyGraphMessage,
        ChemicalCropLinkRegisterModal
    }
})

export default class ItemHiraganaChange extends Vue {

   private baseUrl ='/item_hiragana' 
   private productHiragana: Hiragana[] = []
   private existingProductHiragana: Hiragana[] = []
   private largeCrops = [] as any[];
   private mediumCrops = [] as any[];
   private smallCrops = [] as any[];
   private cropsList = [] as any[];
   private sortOrder = true;
   private showAllCropsFamic = false;
   private isSpinnerLoading = false;
   selectedCropType = null;
   searchHiraganaVal = null;
   searchCropName = null;
   selectedKind = 'UNCONFIRMED';
   tempSelectedCropType = null;
   tempSearchHiraganaVal = null;
   tempSearchCropName = null;
   selectedCropGroup = null;
   tempSelectedCropGroup = null;
   tempSelectedKind = 'UNCONFIRMED';
   private showScrollButton = false;
   
   rows: string [] = [];
   errors: string [] = [];
   isImporting = false;
   isImportBtnDisabled = false;
   deletedProductHiragana: any[] = [];
   importPopupSelectBtn = false
   selectedCropTypeImport = 0
   showChemicalCropLinkModal = false;
   private cropId = ''
   private cropName = ''
   parentCropDetails = []
   searchQueryCropGroup = "";
   tempSearchQueryCropGroup = "";
   isCropGroupDropdownVisible = false;
   cropGroupList :any []= []

   created() {
    this.getFramicDetails()
    this.getCrops();
    this.getLargeCrops();
    this.handleCropGroupChange();
   }

   private addEmptyRow() {
    this.productHiragana.push({
      id : '',
      name: '',
      hiragana: '',
      parentCropName: '',
      parentCropId: null,
      aliasNames: '',
      cropType: null,
      largeCropG: null,
      mediumCropG: null,
      smallCropG: null,
      isDisabled: false,
      processType: 'new',
      hasError: false,
      isConfirm: false,
      searchQueryParentCropName: '',
      isParentCropNameDropdownVisible: false,
      mediumCrops: [],
      smallCrops: [],
      changedFields : [],
      deletedCropFamic:[],
      parentCropNameList: [],
      selectedImportType : 0
    })
   this.inputChanged();

    this.$nextTick(() => {
    const rowRefs = this.$refs.row as HTMLElement[]; // Type assertion
    const lastRow = rowRefs?.[rowRefs.length - 1];
    if (lastRow) {
      lastRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  }  
    
  private async getFramicDetails() {
    this.isSpinnerLoading = true;
    try {
      const res: any = await this.$apiClient.doRequest('get', `${this.baseUrl}?show_crops=${this.selectedKind}&&crops=${this.searchCropName || 'null'}&&hiragana=${this.searchHiraganaVal || 'null'}&&crop_type=${this.selectedCropType}&&crop_group=${this.selectedCropGroup || 'null'}&&crop_group_name=${this.searchQueryCropGroup || 'null'}`);
      this.productHiragana = res.productHiragana.map((item: any) => ({
        ...item,
        processType: 'nochange'
      }));
      this.existingProductHiragana = res.productHiragana;
      await this.initializeCropGroups();
      this.isSpinnerLoading = false;
    } catch (error) {
      console.error("Failed to fetch famic details:", error);
    }
  }

  refreshTable(){
    this.getFramicDetails()
    this.getLargeCrops()
    this.getCrops();
  }

  handleSearch() {
    if (this.showAlertUpdate()) {
      this.isImportBtnDisabled = false
      this.applyHandleSearch();
    } else {
      this.revertTempSearch();
    }
  }

  clearSearchQueryCropGroup() {
    if(this.showAlertUpdate()){
    this.searchQueryCropGroup = "";
    this.tempSearchQueryCropGroup = ""
    this.getFramicDetails();
    }
  }

  hideCropGroupDropdown() {
      this.isCropGroupDropdownVisible = false;
      if(this.tempSearchQueryCropGroup === ""){
        this.searchQueryCropGroup = ""
      }
      this.handleSearch();
  }

  selectCropGroup(group: any) {
    this.tempSearchQueryCropGroup = group.name;
    this.isCropGroupDropdownVisible = false;
  }

  filtereCropGroupDropDown() {
    this.isCropGroupDropdownVisible = true;
  }

  private async applyHandleSearch() {
    this.searchCropName = this.tempSearchCropName;
    this.searchHiraganaVal = this.tempSearchHiraganaVal;
    this.selectedCropType = this.tempSelectedCropType;
    this.selectedKind = this.tempSelectedKind;
    this.selectedCropGroup = this.tempSelectedCropGroup;
    this.searchQueryCropGroup = this.tempSearchQueryCropGroup;
    this.getFramicDetails();
  }

  async handleCropGroupChange() {
    this.cropGroupList = [];
    let urls: string[] = [];
    if (this.tempSelectedCropGroup === '1') {
      urls = [`${this.baseUrl}/largeCrops?flag=false`];
    }
    else if (this.tempSelectedCropGroup === '2') {
      urls = [`${this.baseUrl}/listMediumCrops`];
    }
    else if (this.tempSelectedCropGroup === '3') {
      urls = [`${this.baseUrl}/listSmallCrops`];
    }
    else {
      urls = [
        `${this.baseUrl}/largeCrops?flag=false`,
        `${this.baseUrl}/listMediumCrops`,
        `${this.baseUrl}/listSmallCrops`
      ];
    }
    try {
      const responses = await Promise.all(
        urls.map(url => this.$apiClient.doRequest("get", url))
      );
      this.cropGroupList =[];
      responses.forEach(res => {
        if (res.crops) {
          this.cropGroupList.push(...res.crops);
          this.cropGroupList.sort((a, b) => 
            a.name.localeCompare(b.name, 'ja-JP')
          );
        }
      });
      if(this.tempSearchQueryCropGroup !=""){
        this.handleSearch();
      }
    } catch (error) {
      console.error("Failed loading crop groups:", error);
    }
  }

  get filteredCropGroupList() {
    if (!this.tempSearchQueryCropGroup) {
      return this.cropGroupList;
    }
    const query = this.tempSearchQueryCropGroup.toLowerCase();
    return this.cropGroupList.filter(group =>
      group.name.toLowerCase().includes(query)
    );
  }

  get itemHiraganaModalOpen():boolean{
    return(
      this.importPopupSelectBtn ||
      this.showChemicalCropLinkModal
    )
  }

  private async revertTempSearch() {
    this.tempSearchCropName = this.searchCropName;
    this.tempSearchHiraganaVal = this.searchHiraganaVal;
    this.tempSelectedCropType = this.selectedCropType;
    this.tempSelectedCropGroup = this.selectedCropGroup;
    this.tempSearchQueryCropGroup = this.searchQueryCropGroup;
    this.$nextTick(() => {
      this.tempSelectedKind = this.selectedKind;
    });
  }

  mounted() {
  const scrollDownBtn = document.getElementById("pagebottombtn");
  const scrollUpBtn = document.getElementById("pageupbtn");

  if (!scrollDownBtn || !scrollUpBtn) return;

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // Show "Down" button when scrolled a bit, hide near bottom
    if (scrollTop > 100 && scrollTop + windowHeight < docHeight - 200) {
      scrollDownBtn.classList.add("show");
    } else {
      scrollDownBtn.classList.remove("show");
    }

     if (scrollUpBtn) {
      const atBottom = scrollTop + windowHeight >= docHeight - 50; 
      const scrolledEnoughFromTop = scrollTop > 200; 
      if (!atBottom && scrolledEnoughFromTop) {
          scrollUpBtn.classList.add("show");
      } else {
          scrollUpBtn.classList.remove("show");
      }
    }
  };

  const handleScrollDown = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", handleScroll);
  scrollDownBtn.addEventListener("click", handleScrollDown);
  scrollUpBtn.addEventListener("click", handleScrollUp);

  handleScroll();

  this.$once("hook:beforeDestroy", () => {
    window.removeEventListener("scroll", handleScroll);
    scrollDownBtn.removeEventListener("click", handleScrollDown);
    scrollUpBtn.removeEventListener("click", handleScrollUp);
  });
}


  private updatedRows() {
    this.productHiragana.forEach((currentRow) => {
      if (currentRow.processType === 'nochange'|| currentRow.processType === 'update') {
         const original = this.existingProductHiragana.find(
        (row) => row.id === currentRow.id
      );
      if (!original) return;
      if (currentRow.parentCropId) {
        const hasBasicChanges = currentRow.hiragana !== original.hiragana || currentRow.isConfirm !== original.isConfirm || currentRow.name !== original.name ||  currentRow.parentCropName !== original.parentCropName;
        if (hasBasicChanges ) {
          currentRow.processType = 'update';
        } else {
          currentRow.processType = 'nochange';
        }
      } 
      else {
        if (
          currentRow.name !== original.name ||
          currentRow.hiragana !== original.hiragana ||
          currentRow.cropType !== original.cropType ||
          currentRow.largeCropG !== original.largeCropG ||
          currentRow.mediumCropG !== original.mediumCropG ||
          currentRow.smallCropG !== original.smallCropG ||
          currentRow.isConfirm !== original.isConfirm
        ) {
          currentRow.processType = 'update';
        } else {
          currentRow.processType = 'nochange';
        }
      }
      }
    });
  }  

  private async submit() {
    if (!this.validateBeforeSave()) return;
    const errmsg: string[] = [];

    this.updatedRows();
    
    const newRows = this.productHiragana.filter(item => {
    return item.processType === 'new' &&
          (item.cropType !== null || item.name.trim() !== '' || item.hiragana.trim() !== '');
    });
    const updateRows = this.productHiragana.filter(
      item => item.processType === 'update' && item.id != null && item.id !== ''
    );
    if (newRows.length ==0 && updateRows.length ==0 && this.deletedProductHiragana.length == 0) {
        alert("品目設定一覧に変更されたデータがありません。")
        return false;
    }
     const badParentRows = newRows
      .map((row) => {
        const realIndex = this.productHiragana.indexOf(row);
        return { row, realIndex };
      })
      .filter((r) => r.row.cropType === 0 && (r.row.parentCropId === null && r.row.searchQueryParentCropName!==""));

      for (const bad of badParentRows) {
        const rowNo = bad.realIndex + 1;
        errmsg.push(
          `${rowNo}行目の親作物名「${bad.row.searchQueryParentCropName}」は存在しません。`
        );
      }
    // Validate all rows first
    const validateRows = (rows: any[]) => {
      rows.forEach(crops => {
        if(crops.name.trim()==""){
          crops.hasError = true;
          errmsg.push("作物名を入力してください。");
        }
        if (crops.name.trim().length > 200) {
          crops.hasError = true;
          errmsg.push(`作物名は200文字以内で入力してください（現在は${crops.name.length}文字）`);
        }
        if ((crops.hiragana === null || crops.hiragana.trim() === "") && crops.isConfirm === true) {
          crops.hasError = true;
          errmsg.push(`${crops.name}のひらがなを入力されていません。`);
        }
        if ((crops.hiragana?.trim()?.length || 0) > 200) {
          crops.hasError = true;
          errmsg.push(`ひらがなは200文字以内で入力してください（現在は${crops.hiragana.length}文字）`);
        }
        if(crops.cropType== null){
          crops.hasError = true;
          errmsg.push("種別選択してください。");
        }

      });
    };

    validateRows(newRows);
    validateRows(updateRows);

    if (errmsg.length > 0) {
      window.alert(errmsg.join('\n'));
      return false;
    }

    try {
      const payload = {
          newRows: newRows,
          updateRows: updateRows,
          deletedIds: this.deletedProductHiragana
        };
      if (newRows.length > 0 || updateRows.length > 0 || this.deletedProductHiragana.length > 0) {
        const result = window.confirm("内容を上書きして保存します。よろしいですか。");
        if (!result) {
          return false;
        }
        await this.$apiClient.doRequest("post", `${this.baseUrl}`, payload);
      }
      this.deletedProductHiragana = [];
      this.$toasted.success('保存しました。');
      this.isImportBtnDisabled = false
      this.$store.dispatch('doUpdateIsInputChanged', false);
      this.refreshTable()
    } catch (error) {
      this.deletedProductHiragana = [];
      this.refreshTable()
      this.$toasted.error('保存に失敗しました。');
    }
  }


  private cancelEdit(){
    if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
    this.isImportBtnDisabled = false
    this.deletedProductHiragana =[]        
    this.refreshTable();
    }
    this.$store.dispatch('doUpdateIsInputChanged', false);
  }

  @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
          this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    async getLargeCrops(){
      await this.$apiClient.doRequest('get', `${this.baseUrl}/largeCrops`).then(res => {
          this.largeCrops = res.crops;
      })
      .catch(error => {
          console.error('Failed to fetch largeCrops:', error);
      });
    }


    async getCrops(){
      await this.$apiClient.doRequest('get', `${this.baseUrl}/crops`).then(res => {
          this.cropsList = res.crops;
      })
      .catch(error => {
          console.error('Failed to fetch cropsList:', error);
      });
    }


    validateBeforeSave() {
      let hasDuplicate = false;

      const newRows = this.productHiragana.filter(item => {
      return item.processType === 'new' &&
           (item.cropType !== null || item.name.trim() !== '' || item.hiragana.trim() !== '');
      });
      this.productHiragana.forEach(item => item.hasError = false);

      const existingNames = this.cropsList.map(crop => crop.name?.trim());

       newRows.forEach(item => {
        const trimmedName = (item.name || '').trim();
        if (existingNames.includes(trimmedName)) {
          item.hasError = true;
          hasDuplicate = true;
        }
      });

      if (hasDuplicate) {
        alert('同じ作物名がすでに登録されています。');
        return false;
      }
      return true;
    }

  async onCropTypeChange(item: any): Promise<void> {
    const row = { ...item };
    if(row.id){
    const parentCropDetails = await this.$apiClient.doRequest(
      "get",
      `/item_hiragana/${row.id}/alias_crop_details/`
    );
    if (parentCropDetails.productHiragana.length > 0) {
      alert(`別名を持つ作物の種別は、変更できません。`);
      this.$set(item, "cropType", row.prevCropType);
      return;
    }
    }
    const prevValue = row.prevCropType;
    const cropId    = row.id;
    this.clearParentCropSelection(item);
      if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
        try {
          const res = await this.$apiClient.doRequest(
            "get",
            `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
          );
          if (res.crops && res.crops.length > 0) {
            const message = `「${row.name}」は既に他の作物と紐づいています。`;
            alert(message);

            this.$set(item, "cropType", prevValue);
            return;
          }
          this.$set(item, "largeCropG", null);
          this.$set(item, "mediumCropG", null);
          this.$set(item, "smallCropG", null);
        } catch (error) {
          console.error("Failed to fetch cropType:", error);
        }

      } else {
        this.$set(item, "largeCropG", null);
        this.$set(item, "mediumCropG", null);
        this.$set(item, "smallCropG", null);
        const changed = Array.isArray(item.changedFields) ? [...item.changedFields] : [];
        if (!changed.includes("cropType")) {
          changed.push("cropType");
        }
        this.$set(item, "changedFields", changed);
        this.inputChanged();
      }
    }

    onCheckBoxChange(item: any) {
      if (item.isConfirm === false && (item.cropType === 1 || item.cropType === 2 || item.cropType === 3)) {
        const cropId = item.id; 
        const type = item.cropType;

        this.$apiClient
          .doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`)
          .then(res => {
            if (res.crops && res.crops.length > 0) {
              const message = `「${item.name}」は既に他の作物と紐づいています。`;
              alert(message);

              item.isConfirm = true;
            }
          })
          .catch(error => {
            console.error("Failed to fetch confirm check:", error);
          });
      }else{
        this.inputChanged()
      }
    }   


   async onCropLargeChange(item:any){
    const preLargeCrop = item.prevLargeCrop;
    if (item.cropType === 2 || item.cropType === 3 ) {
      const cropId = item.id; 
      const type = item.cropType;

      this.$apiClient
          .doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`)
          .then(res => {
            if (res.crops && res.crops.length > 0) {
              const message = `「${item.name}」は既に他の作物と紐づいています。`;
              alert(message);
              item.largeCropG = preLargeCrop;
            }else{
                item.mediumCropG = null;
                item.smallCropG = null;
                this.$apiClient.doRequest('get', `${this.baseUrl}/${item.largeCropG}/mediumCrops`).then(res => {
                      this.$set(item, 'mediumCrops', res.crops);
                  })
                  .catch(error => {
                      console.error('Failed to fetch mediumCrops:', error);
                  });
                this.inputChanged();
            }
          })
          .catch(error => {
            console.error("Failed to fetch confirm check:", error);
          });
     }else{
      item.mediumCropG = null;
      item.smallCropG = null;
       item.changedFields = item.changedFields || [];
          if (!item.changedFields.includes("largeCropG")) {
            item.changedFields.push("largeCropG");
          }
      this.$apiClient.doRequest('get', `${this.baseUrl}/${item.largeCropG}/mediumCrops`).then(res => {
            this.$set(item, 'mediumCrops', res.crops);
        })
        .catch(error => {
            console.error('Failed to fetch mediumCrops:', error);
        });
      this.inputChanged();

     }
     const originals = this.productHiragana.filter(
      (p: any) => String(p.parentCropId) === String(item.id)
    );
    originals.map (async (original:any) => {
      if (original) {
      this.$set(original, "largeCropG", item.largeCropG);
      this.$set(original, "mediumCropG", item.mediumCropG);
      this.$set(original, "smallCropG", item.smallCropG);
      const mediumRes = await this.$apiClient.doRequest(
        'get',
        `${this.baseUrl}/${item.largeCropG}/mediumCrops`
      );
      this.$set(item, 'mediumCrops', mediumRes.crops ?? []);
      this.$set(original, "mediumCrops", mediumRes.crops);
    }
    })
    if(item.largeCropG === null) {
      this.clearParentCropSelection(item)
    }
    if(item.processType === 'new') this.getAllLargeCrops(item.largeCropG, item);
   }

   async onCropMediumChange(item:any){
    const preMediumCrop = item.prevMediumCrop;

    if (item.cropType === 2 || item.cropType === 3 ) {
          const cropId = item.id; 
          const type = item.cropType;

        this.$apiClient
          .doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`)
          .then(res => {
            if (res.crops && res.crops.length > 0) {
              const message = `「${item.name}」は既に他の作物と紐づいています。`;
              alert(message);
              item.mediumCropG = preMediumCrop;
            }else{
               item.smallCropG = null;
               this.$apiClient.doRequest('get', `${this.baseUrl}/smallCrops?large_crop=${item.largeCropG}&medium_crop=${item.mediumCropG}`).then(res => {
                this.$set(item, 'smallCrops', res.crops);
            })
            .catch(error => {
                console.error('Failed to fetch mediumCrops:', error);
            });
          this.inputChanged();
            }
          })
          .catch(error => {
            console.error("Failed to fetch confirm check:", error);
          });
      }else{
        item.smallCropG = null;
        item.changedFields = item.changedFields || [];
          if (!item.changedFields.includes("mediumCropG")) {
            item.changedFields.push("mediumCropG");
          }
        this.$apiClient.doRequest('get', `${this.baseUrl}/smallCrops?large_crop=${item.largeCropG}&medium_crop=${item.mediumCropG}`).then(res => {
                this.$set(item, 'smallCrops', res.crops);
            })
            .catch(error => {
                console.error('Failed to fetch mediumCrops:', error);
            });
          this.inputChanged();
      }
      const originalsMedium = this.productHiragana.filter((p: any) => String(p.parentCropId) === String(item.id));
      originalsMedium?.map (async (original:any) => {
      if (original) {
       this.$set(original, "largeCropG", item.largeCropG);
       this.$set(original, "mediumCropG", item.mediumCropG);
       this.$set(original, "smallCropG", item.smallCropG);
       const smallCrop = await this.$apiClient.doRequest(
          'get',
          `${this.baseUrl}/smallCrops?large_crop=${item.largeCropG}&medium_crop=${item.mediumCropG}`
        );
        this.$set(item, 'smallCrops', smallCrop.crops ?? []);
        this.$set(original, 'smallCrops', smallCrop.crops ?? []);
    }
    })
    if(item.mediumCropG === null){
      this.getAllLargeCrops(item.largeCropG, item);
    }
    if(item.processType === 'new' && item.mediumCropG !== null) this.getAllMediumCrops(item.largeCropG, item.mediumCropG, item);
   }

   onCropSmallChange(item:any){
      item.changedFields = item.changedFields || [];
        if (!item.changedFields.includes("smallCropG")) {
          item.changedFields.push("smallCropG");
      }
      const originalSmall = this.productHiragana.filter(
        (p: any) => String(p.parentCropId) === String(item.id)
      );
      originalSmall.map (async(original:any) => {
        if (original) {
        this.$set(original, "largeCropG", item.largeCropG);
        this.$set(original, "mediumCropG", item.mediumCropG);
        this.$set(original, "smallCropG", item.smallCropG);
      }
      })
      if(item.smallCropG === null){
        this.getAllMediumCrops(item.largeCropG, item.mediumCropG, item);
      }
      if(item.processType === 'new' && item.smallCropG !== null) this.getAllSmallCrops(item.largeCropG, item.mediumCropG, item.smallCropG, item);
   }

  async initializeCropGroups() {
    const [mediumRes, smallRes] = await Promise.all([
      this.$apiClient.doRequest('get', `${this.baseUrl}/listMediumCrops`),
      this.$apiClient.doRequest('get', `${this.baseUrl}/listSmallCrops`)
    ]);

    const allMediumCrops = mediumRes.crops;
    const allSmallCrops = smallRes.crops;

    for (const item of this.productHiragana) {
      const filteredMediumCrops = allMediumCrops.filter((crop: any) => crop.largeCropG === item.largeCropG);

      const filteredSmallCrops = allSmallCrops.filter(
        (crop: any) =>
          crop.largeCropG === item.largeCropG &&
          crop.mediumCropG === item.mediumCropG
      );
      this.$set(item, 'mediumCrops', filteredMediumCrops);
      this.$set(item, 'smallCrops', filteredSmallCrops);
    }
  }

  private sort(fieldName: keyof Hiragana): void {
    this.sortOrder = !this.sortOrder;
    this.productHiragana.sort((a, b) => {
        const aValue = a[fieldName];
        const bValue = b[fieldName];
        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;
        if (typeof aValue === 'string' && typeof bValue === 'string') 
            return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        if (typeof aValue === 'number' && typeof bValue === 'number') 
            return this.sortOrder ? aValue - bValue : bValue - aValue;
        return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
    });
 }

 clearSearchCropName() {
    if(this.showAlertUpdate()){
    this.searchCropName = null;
    this.tempSearchCropName = null;
    this.getFramicDetails();
    }
 }

 clearSearchHiragana() {
    if(this.showAlertUpdate()){
    this.searchHiraganaVal = null;
    this.tempSearchHiraganaVal = null;
    this.getFramicDetails();
    }
 }

private deleteRow(item: any, index: number) {
      const isParentCropUsed = this.productHiragana.some(
        (p: any) => p.parentCropId === item.id
      );
      if (isParentCropUsed) {
        alert(`「${item.name}」は既に別名と紐づいています。`);
        return
      }
  const deletedRow = this.productHiragana[index];
  if (!deletedRow) return;
  const cropId = deletedRow.id;
  const type = deletedRow.cropType;

  if (!deletedRow.deletedCropFamic) {
    this.$set(deletedRow, "deletedCropFamic", []);
  }
  const performDelete = () => {
    if (cropId) {
      deletedRow.deletedCropFamic.push({
        cropId,
        name: deletedRow.name,
      });
      this.deletedProductHiragana.push(cropId);
    }
    this.productHiragana.splice(index, 1);
    this.inputChanged()
  };
  if (type === 1 || type === 2 || type === 3) {
    this.$apiClient
      .doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`)
      .then((res) => {
        if (res.crops && res.crops.length > 0) {
           const message = `「${deletedRow.name}」は既に他の作物と紐づいています。`;
          alert(message);
        } else {
          performDelete();
        }
      })
      .catch((error) => {
        console.error("Failed to fetch confirm check:", error);
      });
  } else {
    performDelete();
  }
}

  getAllLargeCrops(largeCropG: string,row: Hiragana){
    this.$apiClient
      .doRequest("get", `${this.baseUrl}/allLargeCrops/${largeCropG}`)
      .then((res) => {
        row.parentCropNameList = res.crops;
      });
  }

  getAllMediumCrops(largeCropG: string, mediumCropG: string, row: Hiragana){
    this.$apiClient
      .doRequest("get", `${this.baseUrl}/allLargeCrops/${largeCropG}/mediumCrops/${mediumCropG}`)
      .then((res) => {
        row.parentCropNameList = res.crops;
      });
  }

  getAllSmallCrops(largeCropG: string, mediumCropG: string, smallCropG: string, row: Hiragana){
    this.$apiClient
      .doRequest("get", `${this.baseUrl}/allLargeCrops/${largeCropG}/mediumCrops/${mediumCropG}/smallCrops/${smallCropG}`)
      .then((res) => {
        row.parentCropNameList = res.crops;
      });
  }

  showAlertUpdate(){
     if(this.$store.getters.isInputChanged){
      const result = window.confirm("変更内容を破棄します。よろしいですか。");
      if (!result) {
        return false;
      }
    }
    this.$store.dispatch('doUpdateIsInputChanged', false);
    return true;
  }

    async handleFileUpload(event: Event): Promise<void> {
      this.importPopupSelectBtn = false;
      if(this.tempSearchCropName || this.tempSearchHiraganaVal){
      this.clearSearchHiragana();
      this.clearSearchCropName();
      this.clearSearchQueryCropGroup();
      }
      this.tempSelectedCropType = null;
      this.selectedCropType = null;
      this.tempSelectedCropGroup = null;
      this.tempSearchQueryCropGroup ="";
      this.selectedCropGroup = null;
      this.searchQueryCropGroup = "";

      const input = event.target as HTMLInputElement | null;
      const file = input?.files?.[0];
      if (!file) return;


      const hiraganaValue = ["大作物群", "中作物群", "小作物群", "作物名", "別名"];
      const selectedType = hiraganaValue[this.selectedCropTypeImport];

      // ✅ File extension validation
      if (!/\.(xls|xlsx)$/i.test(file.name)) {
        alert(".xls または .xlsx ファイルのみアップロード可能です。");
        if (input) input.value = "";
        return;
      }

      this.isImporting = true;
      const reader = new FileReader();

    reader.onload = async (e) => {
      try {
      const expected = [
        "大作物群",
        "中作物群",
        "小作物群",
        "作物名",
        "別名"
      ];  
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      let rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" }) as string[][];
      const excelHeaders = rows[0].map((h) => String(h).trim());
      rows = rows.map(row => row.slice(0, expected.length));
      const headers = rows[0].map((h) => String(h).trim());
        // ✅ Header check
      if (rows.length === 0) {
        alert("シートにデータがありません。");
        return;
      }    
      if (headers.length < expected.length || expected.some((v, i) => headers[i] !== v)) {
        alert("ヘッダーが正しくありません。");
         this.isImporting = false;
        return;
      }

      const nameSet = new Set<string>();
      const aliasSet = new Set<string>();
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        const large  = String(row[0] || "").trim();
        const medium = String(row[1] || "").trim();
        const small  = String(row[2] || "").trim();
        const name   = String(row[3] || "").trim();
        const alias  = String(row[4] || "").trim();
        if (alias !== "" && selectedType === "別名") {
          const aliasList = alias
            .split(/[,、，､|]+/)
            .map(a => a.trim())
            .filter(a => a !== "");
          for (const a of aliasList) {
            if (aliasSet.has(a)) {
              alert(`インポートファイルに同じ別名「${a}」が、存在します。`);
              this.selectedCropTypeImport = 0
              this.isImporting = false;
              return;
            }
            aliasSet.add(a);
          }
        }
        let checkValue = "";
        let typeName = "";
        if (selectedType === "大作物群") {
          if (!large || ["-", "－", "ｰ", "ー", "―", "—"].includes(large.trim())) continue;
          checkValue = large;
          typeName = "大作物群";
        } else if (selectedType === "中作物群") {
          if (!medium || ["-", "－", "ｰ", "ー", "―", "—"].includes(medium.trim())) continue;
          checkValue = medium;
          typeName = "中作物群";
        } else if (selectedType === "小作物群") {
          if (!small || ["-", "－", "ｰ", "ー", "―", "—"].includes(small.trim())) continue;
          checkValue = small;
          typeName = "小作物群";
        } else if (selectedType === "作物名") {
          checkValue = name;
          typeName = "作物名";
        }
        if (checkValue !== "") {
          if (nameSet.has(checkValue)) {
            alert(`インポートファイルに同じ${typeName}「${checkValue}」が、存在します。`);
            this.isImporting = false;
            return;
          }
          nameSet.add(checkValue);
        }
      }
      // ✅ Get existing crops from API
      this.tempSelectedKind = "ALLDATA";
      this.selectedKind = "ALLDATA";
      const res: any = await this.$apiClient.doRequest(
        "get",
        `${this.baseUrl}?show_crops=${this.selectedKind}&&crops=${this.searchCropName || "null"}&&hiragana=${this.searchHiraganaVal || "null"}&&crop_type=${this.selectedCropType}&&crop_group=${this.selectedCropGroup || "null"}&&crop_group_name=${this.searchQueryCropGroup || "null"}`
      );
      await this.getCrops();

      this.productHiragana = res.productHiragana.map((item: any) => ({
        ...item,
        processType: "nochange"
      }));
      this.existingProductHiragana = res.productHiragana;
      await this.initializeCropGroups();

      const dataRows = rows.slice(1);
      const tempHiraganaList: Hiragana[] = [];
      let addedCount = 0;
      let updatedCount = 0;
      let lastValid = { large: "", medium: "", small: "", name: "" };
      const isHyphen = (value: string): boolean => ["-", "－", "ｰ", "ー"].includes(value.trim());
      let hasError = false;

      const uniqueSet = new Set<string>(); // Track unique combinations
        //get all large, medium and small crops details 
        const largeCroptype = this.productHiragana.filter(item => item.cropType === 1); 
        const mediumCroptype = this.productHiragana.filter(item => item.cropType === 2);
        const smallCropType = this.productHiragana.filter(item => item.cropType === 3);
        const cropFamicType = this.productHiragana.filter(item => item.cropType === 0);

        const structuredArray: any = {};
        this.productHiragana.forEach((data: any) => {
          const largeCropKey = data.largeCropG;
          
          if (!structuredArray[largeCropKey]) {
            structuredArray[largeCropKey] = {
              largeCropName: data.largeCropName,
              mediumCrops: {}
            };
          }

          data.mediumCrops?.forEach((mediumCrop: any) => {
            const mediumCropKey = mediumCrop.id;
            
            if (!structuredArray[largeCropKey].mediumCrops[mediumCropKey]) {
              structuredArray[largeCropKey].mediumCrops[mediumCropKey] = {
                ...mediumCrop,
                smallCrops: []
              };
            }
          });

          data.smallCrops?.forEach((smallCrop: any) => {
            // Use type assertion here
            const mediumCrop = structuredArray[largeCropKey]?.mediumCrops[smallCrop.mediumCropG] as any;
            
            if (mediumCrop && Array.isArray(mediumCrop.smallCrops)) {
              const exists = mediumCrop.smallCrops.some((s: any) => s.id === smallCrop.id);
              
              if (!exists) {
                mediumCrop.smallCrops.push(smallCrop);
              }
            }
          });
        });

        //Fetch Name alone from an array.
        const getAllLargeNames = this.getAllNameFromData (largeCroptype);
        const getAllMediumNames = this.getAllNameFromData (mediumCroptype);
        const getAllSmallNames = this.getAllNameFromData (smallCropType);
        const getAllCropNames = this.getAllNameFromData (cropFamicType);

        for (let i = 0; i < dataRows.length; i++) {
          if (hasError) break;

          const [largeRaw, mediumRaw, smallRaw, nameRaw, aliasRaw] = dataRows[i].map((c) => String(c).trim());
          if ([largeRaw, mediumRaw, smallRaw, nameRaw, aliasRaw].every((v) => v === "")) continue;

          const large = isHyphen(largeRaw) ? "" : largeRaw || lastValid.large;
          const medium = isHyphen(mediumRaw) ? "" : mediumRaw || lastValid.medium;
          const small = isHyphen(smallRaw) ? "" : smallRaw || lastValid.small;
          const name = isHyphen(nameRaw) ? "" : nameRaw || lastValid.name;
          lastValid = { large, medium, small, name };
           if ([largeRaw, mediumRaw, smallRaw, nameRaw].every((v) => v === "")) {
            continue;
          }
        const aliasList = aliasRaw ? aliasRaw.split(/[,、，､]+/).map(a => a.trim()).filter(a => a !== ""): [""];
        for (const alias of aliasList) {
          const currentAlias = alias || aliasRaw;

        const record: Hiragana = { id: "", name: "", hiragana: "", searchQueryParentCropName : "", cropType: 0, largeCropG: null, mediumCropG: null, smallCropG: null, parentCropId: "", parentCropName: "", aliasNames: currentAlias, processType: "new", isDisabled: false, isParentCropNameDropdownVisible: false, hasError: false, isConfirm: false, mediumCrops: [], smallCrops: [], deletedCropFamic: [], parentCropNameList: [] , selectedImportType : 0};
        try {
        if (selectedType === "大作物群") {
          if (!large || ["-", "－", "ｰ", "ー", "―", "—"].includes(large.trim())) continue;
          const key = `${large}`;
          if (uniqueSet.has(key)) continue;
          uniqueSet.add(key);
          record.name = large;
          record.largeCropG = null
          record.mediumCropG = null
          record.smallCropG = null;
          record.cropType = 1;
          record.parentCropId = null;
          record.parentCropName = "";
          const largeCropItem= this.productHiragana.find(item => item.name === large);
          record.id = largeCropItem && largeCropItem.id != "" ? largeCropItem.id  : ""
          if(record.id !=null){
          const matchedRecord = this.productHiragana.find((p: any) => p.parentCropId === record.id);
          if (matchedRecord && matchedRecord.cropType !== record.cropType) {
              alert(`別名を持つ作物の種別は、変更できません。`);
              record.cropType = 0;
              this.isImporting = false;
              hasError = true
              break;
          }
          }
            const existingRecord = this.existingProductHiragana.find(
              item => item.id === record.id
            );
            if (existingRecord?.cropType !== record.cropType) {
              const cropId = record.id;
              const prevValue = existingRecord?.cropType;
              if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
                try {
                  const typeRes = await this.$apiClient.doRequest(
                    "get",
                    `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
                  );
                  if (typeRes.crops && typeRes.crops.length > 0) {
                    hasError = true;
                    alert(`「${record.name}」は既に他の作物と紐づいています。`);
                  }
                  if (hasError) break;
                } catch (error) {
                  console.error(error);
                  hasError = true;
                  break;
                }
              }
            }
        } else if (selectedType === "中作物群") {
          if (!medium || ["-", "－", "ｰ", "ー", "―", "—"].includes(large.trim())) continue;
          const key = `${large}_${medium}`;
          if (uniqueSet.has(key)) continue;
          uniqueSet.add(key);
          const isInvalidCrop = (v: string) => ["","-", "－", "ｰ", "ー", "―", "—"].includes(v.trim());

          if(!large){
            const errorColumn = (row: number) => `${row}行目の大作物群が未設定です。`;
            const excelRowNumber = i + 2; 
            alert(errorColumn(excelRowNumber)); 
            this.isImporting = false;
            hasError = true
            break;
          }
            if (!isInvalidCrop(large) && (!getAllLargeNames.includes(large))) {
            alert(`作物名「${name}」で、エラーが発生しました。大作物名「${large}」が未登録です。`);
            this.isImporting = false;
            hasError = true;
            break;
            }
          record.largeCropG = this.getCropIdFromObjectByName(largeCroptype, large) ?? null;
          record.name = medium;
          record.cropType = 2;
          record.mediumCropG = null
          record.smallCropG = null;
          record.parentCropId = null;
          record.parentCropName = "";
          const mediumCropItem= this.productHiragana.find(item => item.name === medium);
          record.id = mediumCropItem && mediumCropItem.id != "" ? mediumCropItem.id  : ""
          if(record.id != ""){
          const matchedRecord = this.productHiragana.find((p: any) => p.parentCropId === record.id);
          if (matchedRecord && matchedRecord.cropType !== record.cropType) {
              alert(`別名を持つ作物の種別は、変更できません。`);
              record.cropType = 0;
              this.isImporting = false;
              hasError = true
              break;
          }
          }
            const existingRecord = this.existingProductHiragana.find(
              item => item.id === record.id
            );
            if (existingRecord?.cropType !== record.cropType) {
              const cropId = record.id;
              const prevValue = existingRecord?.cropType;
              if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
                try {
                  const typeRes = await this.$apiClient.doRequest(
                    "get",
                    `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
                  );
                  if (typeRes.crops && typeRes.crops.length > 0) {
                    hasError = true;
                    alert(`「${record.name}」は既に他の作物と紐づいています。`);
                  }
                  if (hasError) break;
                } catch (error) {
                  console.error(error);
                  hasError = true;
                  break;
                }
              }
            }
          const existingLargeCrop = this.existingProductHiragana.find(item => item.id === record.id)
          if(existingLargeCrop?.largeCropG !== record.largeCropG){
          if (record.cropType === 2 || record.cropType === 3 ) {
          const cropId = record.id; 
          const type = record.cropType;
            try {
            const typeRes = await this.$apiClient.doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`);
                if (typeRes.crops && typeRes.crops.length > 0) {
                  const message = `「${record.name}」は既に他の作物と紐づいています。`;
                  hasError = true;
                  alert(message);
                  if (hasError) break;
                }
              }
              catch(error) {
              console.error(error);
                  hasError = true;
                  break;
            }
          }
          }
        } else if (selectedType === "小作物群") {
          if (!small || ["-", "－", "ｰ", "ー", "―", "—"].includes(large.trim())) continue;
          const key = `${large}_${medium}_${small}`;
          if (uniqueSet.has(key)) continue;
          uniqueSet.add(key);
          const isInvalidCrop = (v: string) => ["","-", "－", "ｰ", "ー", "―", "—"].includes(v.trim());
          if (small && (!large || !medium)) {
            const excelRowNumber = i + 2;
            const errorMessage = !large
              ? `${excelRowNumber}行目の大作物群が未設定です。`
              : `${excelRowNumber}行目の中作物群が未設定です。`;
            this.isImporting = false;
            alert(errorMessage);
            hasError = true;
            break;
          }

            if (!isInvalidCrop(large) && (!getAllLargeNames.includes(large))) {
            alert(`作物名「${small}」で、エラーが発生しました。大作物名「${large}」が未登録です。`);
            this.isImporting = false;
            hasError = true;
            break;
            }
            if (!isInvalidCrop(medium) && (!getAllMediumNames.includes(medium))) {
            alert(`作物名「${small}」で、エラーが発生しました。中作物名「${medium}」が未登録です。`);
            this.isImporting = false;
            hasError = true;
            break;
            }
          record.largeCropG = this.getCropIdFromObjectByName(largeCroptype, large) ?? null;
          record.mediumCropG = this.getCropIdFromObjectByName(mediumCroptype, medium) ?? null;
          record.name = small;
          record.cropType = 3;
          record.parentCropId = null;
          record.parentCropName = "";
          const smallCropItem= this.productHiragana.find(item => item.name === small);
          record.id = smallCropItem && smallCropItem.id != "" ? smallCropItem.id  : ""
          if(record.id !=null){
          const matchedRecord = this.productHiragana.find((p: any) => p.parentCropId === record.id);
          if (matchedRecord && matchedRecord.cropType !== record.cropType) {
              alert(`別名を持つ作物の種別は、変更できません。`);
              record.cropType = 0;
              this.isImporting = false;
              hasError = true
              break;
          }
        }
           if (record.largeCropG) {
            const largeCropsData = structuredArray[record.largeCropG];
            if (largeCropsData != null && largeCropsData != undefined) {
              const mediumCropsData = largeCropsData.mediumCrops;
              if (record.mediumCropG === null) {
                this.$set(record, 'mediumCrops', mediumCropsData);
              } 
              else if (record.mediumCropG) {
                if (Object.keys(mediumCropsData).length > 0 && Object.prototype.hasOwnProperty.call(mediumCropsData, record.mediumCropG)) {
                  this.$set(record, 'mediumCrops', mediumCropsData);
                } else {
                  alert(`作物名「${small}」で、エラーが発生しました。中作物名「${medium}」の紐付けがありません。`);
                  this.isImporting = false;
                  hasError = true;
                  break;
                }
              }
            }
          }
        if (smallCropItem?.id != null && smallCropItem?.id !== "") {
            const existingRecord = this.existingProductHiragana.find(
              item => item.id === record.id
            );
            if (existingRecord?.cropType !== record.cropType) {
              const cropId = record.id;
              const prevValue = existingRecord?.cropType;
              if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
                try {
                  const typeRes = await this.$apiClient.doRequest(
                    "get",
                    `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
                  );
                  if (typeRes.crops && typeRes.crops.length > 0) {
                    hasError = true;
                    alert(`「${record.name}」は既に他の作物と紐づいています。`);
                  } 
                  if (hasError) break;
                } catch (error) {
                  console.error(error);
                  hasError = true;
                  break;
                }
              }
            }
        }
        const existingCrop = this.existingProductHiragana.find(item => item.id === record.id)
        if(existingCrop?.largeCropG !== record.largeCropG){
          if (record.cropType === 2 || record.cropType === 3 ) {
          const cropId = record.id; 
          const type = record.cropType;
            try {
            const typeRes = await this.$apiClient.doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`);
                if (typeRes.crops && typeRes.crops.length > 0) {
                  const message = `「${record.name}」は既に他の作物と紐づいています。`;
                  hasError = true;
                  alert(message);
                  if (hasError) break;
                }else{
                    this.$apiClient.doRequest('get', `${this.baseUrl}/${record.largeCropG}/mediumCrops`).then(res => {
                          this.$set(record, 'mediumCrops', res.crops);
                      })
                      .catch(error => {
                          console.error('Failed to fetch mediumCrops:', error);
                      });
                }
              }
              catch(error) {
                console.error(error);
                hasError = true;
                break;
            }
          }
        }
        if(existingCrop?.mediumCropG !== record.mediumCropG){
        if (record.cropType === 2 || record.cropType === 3 ) {
              const cropId = record.id; 
              const type = record.cropType;
            try{
          const typeRes = await this.$apiClient
              .doRequest("get", `${this.baseUrl}/cropType?old_type=${type}&crop_id=${cropId}`);
                if (typeRes.crops && typeRes.crops.length > 0) {
                  hasError = true;
                  const message = `「${record.name}」は既に他の作物と紐づいています。`;
                  alert(message);
                  if (hasError) break;
                }else{
                  this.$apiClient.doRequest('get', `${this.baseUrl}/smallCrops?large_crop=${record.largeCropG}&medium_crop=${record.mediumCropG}`).then(res => {
                    this.$set(record, 'smallCrops', res.crops);
                })
                .catch(error => {
                    console.error('Failed to fetch mediumCrops:', error);
                });
                }
              } catch(error) {
                console.error("Failed to fetch confirm check:", error);
              }
          }
        }
        
        } else if (selectedType === "作物名") {
        if (!small && !medium && !large && !name || ["-", "－", "ｰ", "ー", "―", "—"].includes(large.trim())) continue;
        const isInvalidCrop = (v: string) => ["","-", "－", "ｰ", "ー", "―", "—"].includes(v.trim());
          let errorMessage
          const excelRowNumber = i + 2;
          if(!large && medium && small){
            errorMessage = `${excelRowNumber}行目の大作物群が未設定です。`
            this.isImporting = false;
            hasError = true;
            break;
          }
          else if(large && !medium && small){
            errorMessage = `${excelRowNumber}行目の中作物群が未設定です。`
            this.isImporting = false;
            hasError = true;
            break;
          }
          if (errorMessage) {
            alert(errorMessage);
          }
          const key = `${large}_${medium}_${small}_${name}`;
          if (uniqueSet.has(key)) continue;
          uniqueSet.add(key);
        // ✅ Validation (only for valid crops)
        if (!isInvalidCrop(large) && (!getAllLargeNames.includes(large))) {
          alert(`作物名「${name}」で、エラーが発生しました。大作物名「${large}」が未登録です。`);
          this.isImporting = false;
          hasError = true;
          break;
        }

        if (!isInvalidCrop(medium) && (!getAllMediumNames.includes(medium))) {
          alert(`作物名「${name}」で、エラーが発生しました。中作物名「${medium}」が未登録です。`);
          this.isImporting = false;
          hasError = true;
          break;
        }

        if (!isInvalidCrop(small) && (!getAllSmallNames.includes(small))) {
          alert(`作物名「${name}」で、エラーが発生しました。小作物名「${small}」が未登録です。`);
          this.isImporting = false;
          hasError = true;
          break;
        }

        const foundItem = this.productHiragana.find(item => item.name === name);
        record.id = foundItem ? foundItem.id : "";
        record.largeCropG = this.getCropIdFromObjectByName(largeCroptype, large) ?? null;
        record.mediumCropG = this.getCropIdFromObjectByName(mediumCroptype, medium) ?? null;
        record.smallCropG = this.getCropIdFromObjectByName(smallCropType, small) ?? null;
        record.name = name;
        record.cropType = 0;
        record.parentCropId = null;
        record.parentCropName = "";
        record.selectedImportType = 3
          if (record.largeCropG) {
            const largeCropsData = structuredArray[record.largeCropG];
            if (largeCropsData != null && largeCropsData != undefined) {
              const mediumCropsData = largeCropsData.mediumCrops;
              if (record.mediumCropG === null) {
                this.$set(record, 'mediumCrops', mediumCropsData);
              } 
              else if (record.mediumCropG) {
                  if (Object.keys(mediumCropsData).length > 0 && Object.prototype.hasOwnProperty.call(mediumCropsData, record.mediumCropG)) {
                  this.$set(record, 'mediumCrops', mediumCropsData);
                } else {
                  alert(`作物名「${name}」で、エラーが発生しました。中作物名「${medium}」の紐付けがありません。`);
                  this.isImporting = false;
                  hasError = true;
                  break;
                }
              }
            }
          }
          if (record.largeCropG && record.mediumCropG) {
            const largeCropsData = structuredArray[record.largeCropG];
            if (largeCropsData != null && largeCropsData != undefined) {
              const mediumCropsData = structuredArray[record.largeCropG].mediumCrops;
              if (Object.keys(mediumCropsData).length > 0 && mediumCropsData[record.mediumCropG]) {
                this.$set(record, 'mediumCrops', mediumCropsData);
                if (record.smallCropG) {
                  const currentMediumCrop = mediumCropsData[record.mediumCropG];
                  if (currentMediumCrop && currentMediumCrop.smallCrops && currentMediumCrop.smallCrops.length > 0) {
                    const smallCropExists = currentMediumCrop.smallCrops.some(
                      (smallCrop: any) => smallCrop.id === record.smallCropG
                    );
                    if (smallCropExists) {
                      this.$set(record, 'smallCrops', currentMediumCrop.smallCrops);
                    } else {
                      alert(`作物名「${name}」で、エラーが発生しました。小作物名「${small}」の紐付けがありません。`);
                      this.isImporting = false;
                      hasError = true;
                      break;
                    }
                  }
                } else {
                  const currentMediumCrop = mediumCropsData[record.mediumCropG];
                  this.$set(record, 'smallCrops', currentMediumCrop.smallCrops);
                }
              } 
            }
          }
        if (foundItem?.id != null && foundItem?.id !== "") {
            const existingRecord = this.existingProductHiragana.find(
              item => item.id === record.id
            );
            if (existingRecord?.cropType !== record.cropType) {
              const cropId = record.id;
              const prevValue = existingRecord?.cropType;
              if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
                try {
                  const typeRes = await this.$apiClient.doRequest(
                    "get",
                    `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
                  );
                  if (typeRes.crops && typeRes.crops.length > 0) {
                    hasError = true;
                    alert(`「${record.name}」は既に他の作物と紐づいています。`);
                  }
                  if (hasError) break;
                } catch (error) {
                  console.error(error);
                  hasError = true;
                  break;
                }
              }
            }
        }
        const aliasChildren = this.productHiragana.filter(item => item.parentCropName === record.name &&  (item.largeCropG !== record.largeCropG || item.mediumCropG !== record.mediumCropG || item.smallCropG !== record.smallCropG));
          if (aliasChildren && aliasChildren.length > 0) {
            for (const alias of aliasChildren) {
              if (alias.largeCropG !== record.largeCropG) {
                alias.largeCropG = record.largeCropG;
              }
              if (alias.mediumCropG !== record.mediumCropG) {
                alias.mediumCropG = record.mediumCropG;
              }
              if (alias.smallCropG !== record.smallCropG) {
                alias.smallCropG = record.smallCropG;
              }
              this.$set(alias, "smallCrops", record.smallCrops);
              this.$set(alias, "mediumCrops", record.mediumCrops);
                alias.processType = "nochange";
                alias.changedFields = [];
            }
            
          }
        } else if (selectedType === "別名"){
          if (!currentAlias || ["","-", "－", "ｰ", "ー"].includes(currentAlias.trim())) continue;
          const isInvalidCrop = (v: string) => ["", "-", "－", "ｰ", "ー"].includes(v.trim());
          const tempParentCropId: string | null = null;
          let tempParentCropName: string | null = null;
          let tempLargeCropG: string | null = null;
          let tempMediumCropG: string |null = null;
          let tempSmallCropG: string | null = null;
            let errorMessage
            const excelRowNumber = i + 2;
            if(!large && medium && small){
              errorMessage = `${excelRowNumber}行目の大作物群が未設定です。`;
              this.isImporting = false;
              hasError = true;
              break;
            }
            else if(large && !medium && small){
              errorMessage = `${excelRowNumber}行目の中作物群が未設定です。`;
              this.isImporting = false;
              hasError = true;
              break;
            } else if((!large || !medium ) && small){
              errorMessage = !large ? `${excelRowNumber}行目の大作物群が未設定です。` : `${excelRowNumber}行目の中作物群が未設定です。` ;
              this.isImporting = false;
              hasError = true;
              break;
            }
            else if(large && medium && small && !name){
              errorMessage = `${excelRowNumber}行目の作物名が未設定です。`
              this.isImporting = false;
              hasError = true;
              break;
            }
            if (errorMessage) {
              alert(errorMessage);
            }
            const cropAliasItem = this.productHiragana.find(item =>  item.name === currentAlias);
            const parentItem = this.productHiragana.find(item =>  item.name === name);
            if( parentItem && parentItem?.id){
              record.parentCropId = parentItem?.id;
            } else {
              record.parentCropId = null;
            }
            tempParentCropName = currentAlias !== "" ? name : "";
            tempLargeCropG = this.getCropIdFromObjectByName(largeCroptype, large) ?? null;
            tempMediumCropG = this.getCropIdFromObjectByName(mediumCroptype, medium) ?? null;
            tempSmallCropG =  this.getCropIdFromObjectByName(smallCropType, small) ?? null;
            record.id = cropAliasItem?.id ?? ""
            record.name = currentAlias ? currentAlias : name;
            record.parentCropName = tempParentCropName ? tempParentCropName : "";
            record.largeCropG = tempLargeCropG;
            record.mediumCropG = tempMediumCropG;
            record.smallCropG = tempSmallCropG;
            record.cropType = 0;
            record.selectedImportType = 3
             if (cropAliasItem?.id != null && cropAliasItem?.id !== "") {
            const existingRecord = this.existingProductHiragana.find(
              item => item.id === record.id
            );
            if (existingRecord?.cropType !== record.cropType) {
              const cropId = record.id;
              const prevValue = existingRecord?.cropType;
              if (prevValue === 1 || prevValue === 2 || prevValue === 3) {
                try {
                  const typeRes = await this.$apiClient.doRequest(
                    "get",
                    `${this.baseUrl}/cropType?old_type=${prevValue}&crop_id=${cropId}`
                  );
                  if (typeRes.crops && typeRes.crops.length > 0) {
                    hasError = true;
                    alert(`「${record.name}」は既に他の作物と紐づいています。`);
                  }
                  if (hasError) break;
                } catch (error) {
                  console.error(error);
                  hasError = true;
                  break;
                }
              }
            }
        }
            if (cropAliasItem?.parentCropId != "") {
              const sameAlias = this.productHiragana.find((item: any) => 
                item.parentCropId && item.name === currentAlias
              );
              if (sameAlias && sameAlias.parentCropName !== name) {
                const errorMsg = `既に別名「${currentAlias}」は、他の親作物名「${sameAlias.parentCropName}」と紐づいています。`;
                alert(errorMsg);
                this.isImporting = false;
                hasError = true;
                break;
              }
            }
            
            if (!isInvalidCrop(large) && (!getAllLargeNames.includes(large))) {
              alert(`作物名「${currentAlias}」で、エラーが発生しました。大作物名「${large}」が未登録です。`);
              this.isImporting = false;
              hasError = true;
              break;
            }

            if (!isInvalidCrop(medium) && (!getAllMediumNames.includes(medium))) {
              alert(`作物名「${currentAlias}」で、エラーが発生しました。中作物名「${medium}」が未登録です。`);
            this.isImporting = false;
              hasError = true;
              break;
            }

            if (!isInvalidCrop(small) && (!getAllSmallNames.includes(small))) {
              alert(`作物名「${currentAlias}」で、エラーが発生しました。小作物名「${small}」が未登録です。`);
            this.isImporting = false;
              hasError = true;
              break;
            }

            if (!isInvalidCrop(name) && (!getAllCropNames.includes(name))) {
              alert(`作物名「${currentAlias}」で、エラーが発生しました。親作物名「${name}」が未登録です。`);
              this.isImporting = false;
              hasError = true;
              break;
            }
          if (tempLargeCropG) {
            const largeCropsData = structuredArray[tempLargeCropG];
            if (largeCropsData != null && largeCropsData != undefined) {
              const mediumCropsData = largeCropsData.mediumCrops;
              if (tempMediumCropG === null) {
                this.$set(record, 'mediumCrops', mediumCropsData);
              } 
              else if (tempMediumCropG) {
                if (Object.keys(mediumCropsData).length > 0 && Object.prototype.hasOwnProperty.call(mediumCropsData, tempMediumCropG)) {
                  this.$set(record, 'mediumCrops', mediumCropsData);
                } else {
                  alert(`作物名「${currentAlias}」で、エラーが発生しました。中作物名「${medium}」の紐付けがありません。`);
                  this.isImporting = false;
                  hasError = true;
                  break;
                }
              }
            }
          }

          if (record.largeCropG && record.mediumCropG) {
            const largeCropsData = structuredArray[record.largeCropG];
            if (largeCropsData != null && largeCropsData != undefined) {
              const mediumCropsData = structuredArray[record.largeCropG].mediumCrops;
              if (Object.keys(mediumCropsData).length > 0 && mediumCropsData[record.mediumCropG]) {
                this.$set(record, 'mediumCrops', mediumCropsData);
                if (record.smallCropG) {
                  const currentMediumCrop = mediumCropsData[record.mediumCropG];
                  if (currentMediumCrop && currentMediumCrop.smallCrops && currentMediumCrop.smallCrops.length > 0) {
                    const smallCropExists = currentMediumCrop.smallCrops.some(
                      (smallCrop: any) => smallCrop.id === record.smallCropG
                    );
                    if (smallCropExists) {
                      this.$set(record, 'smallCrops', currentMediumCrop.smallCrops);
                    } else {
                      alert(`作物名「${currentAlias}」で、エラーが発生しました。小作物名「${small}」の紐付けがありません。`);
                      this.isImporting = false;
                      hasError = true;
                      break;
                    }
                  }
                } else {
                  const currentMediumCrop = mediumCropsData[record.mediumCropG];
                   this.$set(record, 'smallCrops', currentMediumCrop.smallCrops);
                }
              } 
            }
          } 

        if (tempParentCropId) { 
          const parentId = tempParentCropId; 
          // Fetch parent crop 
          const parentDetail = this.existingProductHiragana.find((e: any) => e.id === parentId); 
          if (parentDetail) { 
            const errorColumn = (row: number, colName: string) => `インポートしたエクセルの${row}行目の${colName}が正しくありません`;
          const excelRowNumber = i + 2; 
          // // ---- Compare 大作物群 ---- 
          if (parentDetail.largeCropG !== tempLargeCropG) { 
          alert(errorColumn(excelRowNumber, "大作物群")); 
          this.isImporting = false;
          hasError = true; 
          break; 
          } 
          // // ---- Compare 中作物群 ---- 
          if (parentDetail.mediumCropG !== tempMediumCropG) { 
          alert(errorColumn(excelRowNumber, "中作物群")); 
          this.isImporting = false;
          hasError = true; 
          break; 
          } 
          // // ---- Compare 小作物群 ---- 
          if (parentDetail.smallCropG !== tempSmallCropG) { 
          alert(errorColumn(excelRowNumber, "小作物群")); 
          this.isImporting = false;
          hasError = true; 
          break; 
          } 
      }
    }
        }

    if (hasError) break;

        const updateRecordWithMediumCrops = async (record:any, existing:any, existingIndex:number) => {
        if (!record.mediumCrops || record.mediumCrops.length === 0) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        this.$set(this.productHiragana, existingIndex, {
            ...existing,
            ...record,
            id: existing.id,
            mediumCrops: record.mediumCrops || [], 
            isConfirm: existing.isConfirm,
            hiragana: existing.hiragana,
        });
        };
      const existingIndex = this.productHiragana.findIndex((r) => r.name === record.name);
      if (existingIndex !== -1) {
        const existing = this.productHiragana[existingIndex];
        const changedFields: string[] = [];
        const isAlias = !!existing.parentCropId;
          if (!isAlias) {
            if (existing.largeCropG !== record.largeCropG) changedFields.push("largeCropG");
            if (existing.mediumCropG !== record.mediumCropG) changedFields.push("mediumCropG");
            if (existing.smallCropG !== record.smallCropG) changedFields.push("smallCropG");
            if (existing.name !== record.name) changedFields.push("name");
            if (existing.cropType !== record.cropType) changedFields.push("cropType");
            if(this.selectedCropTypeImport === 4){
            if (existing.parentCropName !== record.parentCropName) changedFields.push("parentCropName");
            }
          }
        if (changedFields.length > 0) {
          updatedCount++;
          const updatedHiraganaRecord = { ...record, processType: "update", changedFields : changedFields };
          await updateRecordWithMediumCrops(updatedHiraganaRecord, existing, existingIndex);
          const updatedRecord = this.productHiragana.splice(existingIndex, 1)[0];
          const newIndex = this.productHiragana.findIndex(r => r.processType === "new");
          if (newIndex === -1) {
            this.productHiragana.push(updatedRecord);
            } else {
            this.productHiragana.splice(newIndex, 0, updatedRecord);
          }
            }
          } else {
            addedCount++;
            tempHiraganaList.push(record);
          }
          } catch (err) {
            console.error(err);
            break;
          }
        }

        }
         this.isImporting = false;
          if (tempHiraganaList.length > 0 && !hasError) {
            this.productHiragana.push(...tempHiraganaList);
          }
          if(!hasError){
          this.isImportBtnDisabled = addedCount !== 0 || updatedCount !== 0;
          }
          if (addedCount !== 0 || updatedCount !== 0) {
          this.$store.dispatch('doUpdateIsInputChanged', true);
          } else {
            this.$store.dispatch('doUpdateIsInputChanged', false);
          }
          if(!hasError){
          alert(`インポートが完了しました。追加 ${addedCount} 件、更新 ${updatedCount} 件`);  
          }
          this.selectedCropTypeImport = 0
          if(!hasError && (addedCount !== 0 || updatedCount !== 0)){
           this.$nextTick(() => {
          const rowRefs = this.$refs.row as HTMLElement[]; // Type assertion
            const lastRow = rowRefs?.[rowRefs.length - 1];
              if (lastRow) {
              lastRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            });
          }
        } catch (err) {
          console.error(err);
          alert("インポート中にエラーが発生しました。");
        } finally {
          this.isImporting = false;
          if (input) input.value = "";
        }
      };

      reader.readAsArrayBuffer(file);
      this.$root.$emit('header-inert', false);
    }


    getAllNameFromData (data:any) {
      if(data != null && data.length > 0 ) {
      const cropsName = data.map((crop:any) => crop.name);
      return cropsName;
      }else {
        return [];
      }
    }

    getCropIdFromObjectByName(data:any, cropName:string) {
      if(data != null && data.length > 0 ) {
        const cropObject = data.find((crop:any) => crop.name === cropName);
        return cropObject?.id ?? null;
      }else {
        return null;
      }
    }


onInputChange(item: any, action: string) {
  this.inputChanged();

  const fieldMap: Record<string, string> = {
    hiragana: "hiragana",
    cropName: "name",
  };
  const fieldKey = fieldMap[action];
  if (!fieldKey) return;

  item.changedFields = item.changedFields || [];

  const currentValue = item[fieldKey];
  const originalValue = item[`${fieldKey}Origin`] ?? ""; 

  const hasChanged = currentValue !== originalValue;

  if (hasChanged) {
    if (!item.changedFields.includes(action)) {
      item.changedFields.push(action);
    }
  } else {
    item.changedFields = item.changedFields.filter((f: string) => f !== action);
  }
}

@Emit()
  cancel(){
    this.importPopupSelectBtn = false
    this.selectedCropTypeImport = 0
    this.$root.$emit('header-inert', false);
  }

  openChemicalCropLinkModal(item:any) {
        this.showChemicalCropLinkModal = true;
        this.cropId = item.id;
        this.cropName = item.name;
    }


beforeFileUploadBtnSelect(action:string){
  if(action === "modal"){
    this.selectedCropTypeImport = 0
    this.$root.$emit('header-inert', true);
  }
 if(!this.showAlertUpdate()){
  this.importPopupSelectBtn = true
  }else{
  this.importPopupSelectBtn = true
  }
}

clearParentCropSelection(item: any) {
  item.parentCropNameList = [];
  item.parentCropName = "";
  item.searchQueryParentCropName = "";
  item.parentCropId = null;
}

filteredParentCropName(row: Hiragana) {
  if (!row.searchQueryParentCropName) return row.parentCropNameList;

  return row.parentCropNameList.filter((item: any) =>
    item.name.toLowerCase().includes(row.searchQueryParentCropName.toLowerCase())
  );
}

selectParentCropName(selected: { id: string | number; name: string }, row: Hiragana) {
  row.searchQueryParentCropName = selected.name;
  row.parentCropName = selected.name;
  row.parentCropId = selected.id ? String(selected.id) : null;

  row.changedFields = row.changedFields || [];
  if (!row.changedFields.includes("parentCropName")) {
    row.changedFields.push("parentCropName");
  }

  row.isParentCropNameDropdownVisible = false;
}

hideParentCropNameDropdown(row: Hiragana) {
  row.isParentCropNameDropdownVisible = false;
}

onParentCropNameInput(row: Hiragana) {
  row.isParentCropNameDropdownVisible = true;
  row.parentCropId = null;
  row.changedFields = row.changedFields || [];
  if (!row.changedFields.includes("parentCropName")) {
    row.changedFields.push("parentCropName");
  }
}

}

